// extracted by mini-css-extract-plugin
export var borderRadius = "_59-4";
export var large = "_59-3";
export var logoContainer = "_59-0";
export var nameLogo = "_59-2";
export var small = "_59-1";